import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LocationAclEffects } from './location-acl.effects';
import { locationAclReducer } from './location-acl.reducer';
import { SecurityService } from '@era/locations-sdk';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('locationAcls', locationAclReducer),
    EffectsModule.forFeature([LocationAclEffects]),
  ],
  providers: [SecurityService],
})
export class LocationAclStoreModule {}
